import React, { FC, useState } from "react";

import { ArchiveProject } from "@/features/archive/model/archive/ArchivedProjectsRequest";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { Translate } from "@/app/application/Translate";


interface PdfMenuProps {
	row: ArchiveProject;
	pdfColor: string;
}

export const PdfMenu: FC<PdfMenuProps> = ({ row, pdfColor }) => {
	const [pdfMenu, setPdfMenu] = useState(null);
	const openPdfMenu = Boolean(pdfMenu);

	const handlePdfMenu = (event: any) => {
		setPdfMenu(event.currentTarget);
	};

	return (
		<>
			<IconButton onClick={handlePdfMenu}>
				<PictureAsPdfIcon sx={{ color: pdfColor }} />
			</IconButton>
			<Menu
				open={openPdfMenu}
				onClose={() => setPdfMenu(null)}
				anchorEl={pdfMenu}
				slotProps={{
					paper: { sx: { borderRadius: 2, mt: 1.5 } },
				}}
			>
				<MenuItem onClick={() => setPdfMenu(null)}>
					<a href={row.Link} target="_blank" rel="noreferrer">
						<Translate String="Auto.Features.Archive.Ui.Components.History.PdfMenu.L34C58.Preview">Preview</Translate>
					</a>
				</MenuItem>
				<MenuItem onClick={() => setPdfMenu(null)}>
					<a href={row.Link} download target="_blank" rel="noreferrer">
						<Translate String="Auto.Features.Archive.Ui.Components.History.PdfMenu.L39C67.Download">Download</Translate>
					</a>
				</MenuItem>
			</Menu>
		</>
	);
};
